import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProductionDataProvider } from './contexts/ProductionDataContext';
import { LoadingTrackerProvider } from './contexts/LoadingTrackerContext';
import { ToastProvider } from './components/ui/Toast';
import AppErrorBoundary from './components/ui/AppErrorBoundary';
import Login from './components/Login';
import Presentation from './components/presentation/Presentation';
import { useAppViewport } from './hooks/useAppViewport';

function AppContent() {
  const { authenticated, loading, user, logout } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 rounded-full border-2 border-yellow-500/30 border-t-yellow-400 animate-spin" />
          <p className="text-[11px] uppercase tracking-[0.2em] text-yellow-500/80">Loading</p>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return <Login />;
  }

  return <Presentation userEmail={user?.email || ''} onLogout={logout} />;
}

function App() {
  useAppViewport();

  return (
    <AppErrorBoundary>
      <AuthProvider>
        <LoadingTrackerProvider>
          <ProductionDataProvider>
            <ToastProvider>
              <AppContent />
            </ToastProvider>
          </ProductionDataProvider>
        </LoadingTrackerProvider>
      </AuthProvider>
    </AppErrorBoundary>
  );
}

export default App;
